import { pageRaw } from "@/lib/blocks";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register"];
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !NO_RETRY.some((u) => url.includes(u))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
      } catch (e) {
        return Promise.reject(error);
      } finally {
        refreshing = null;
      }
      return api(cfg);
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const upgradeAction = { label: "Upgrade", onClick: () => window.location.assign("/billing") };

export const safeNext = (n) => (n && n.startsWith("/") && !n.startsWith("//") ? n : null);

export const withNext = (path, next) => (next ? `${path}?next=${encodeURIComponent(next)}` : path);

export const errorToastOpts = (e) => (e?.response?.status === 402 ? { action: upgradeAction, duration: 8000 } : undefined);

const LINK_RE = /\[\[([^[\]|]+)(?:\|[^[\]]*)?\]\]/g;

export const extractLinks = (content) => [...(content || "").matchAll(LINK_RE)].map((m) => m[1].trim());

export const findByTitle = (pages, title) =>
  pages.find((p) => p.title.toLowerCase() === (title || "").trim().toLowerCase());

export const backlinksFor = (pages, page) =>
  pages.filter((p) => p.id !== page.id && (
    extractLinks(pageRaw(p)).some((t) => t.toLowerCase() === page.title.toLowerCase()) ||
    (p.sections || []).some((s) => s.facts.some((f) => f.items.some((i) => i.page_id === page.id)))
  ));
